import React from "react";
import Page, { PageProps } from "../Page";
import { ISettingsPresenter } from "../../../presenter/settings/SettingsPresenter";
import PasswordChangeForm from "../authentication/PasswordChangeForm";
import { IChangePasswordPresenter } from "../../../presenter/authentication/ChangePasswordPresenter";
import ChangeLanguageForm from "../../components/settings/ChangeLanguageForm";
import { Typography, Divider } from "antd";

export interface Props extends PageProps {}
export interface State extends ISettingsPresenter, IChangePasswordPresenter {}

export default class SettingsPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      setPasswordValue,
      passwordPresentationModel,
      isChangeButtonDisabled,
      changePassword,
      validationPasswordErrors,
      languages,
      currentLanguageCode,
      changeLanguage
    } = this.state;

    return (
      <Page {...this.props}>
        <Typography.Title style={{ fontSize: 16 }}>
          {translate("settings.language_title")}
        </Typography.Title>
        <ChangeLanguageForm
          languages={languages}
          translate={translate}
          currentLanguageCode={currentLanguageCode}
          changeLanguage={changeLanguage}
        />
        <Divider type={"horizontal"} />
        <Typography.Title style={{ fontSize: 16 }}>
          {translate("settings.password_title")}
        </Typography.Title>

        <PasswordChangeForm
          password={passwordPresentationModel}
          translate={translate}
          setPasswordValue={setPasswordValue}
          disableButton={isChangeButtonDisabled}
          changePassword={changePassword}
          validationErrors={validationPasswordErrors}
          loading={this.state.loaders.changePasswordLoader}
        />
      </Page>
    );
  }
}
